module.exports = __webpack_public_path__ + "img/logo.e0598248.png";